import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.NODE_ENV === 'production' ? 'https://engagelive.alzaabigroup.com/' : 'http://localhost:5200/';

export const socket = io(URL);